module.exports = "\n<app-layout-header></app-layout-header>\n\n<flash-messages></flash-messages>\n\n<router-outlet></router-outlet>\n\n<app-layout-footer></app-layout-footer>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main